import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';

class PrototypeText extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            locale: props.locale,
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate() {

    }

    render() {
        return (
            <div className={`object-container`}>
                <div className="standard-block prototype">
                <div className="paragraph-content-wrapper left-asset">
                    <div className="asset-column">
                        <div className={`asset-image-wrapper padded_border`} style={{width: `200px`}}>
                            <img src={require(`../../../assets/images/placeholder/placeholder_thumbnail.jpg`)} alt=""/>
                        </div>
                    </div>
                    <div className="content-column">
                        <h4  dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_TEXT_TITLE}}/>
                        <div dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_TEXT}}/>
                    </div>
                </div>
                </div>
            </div>
        );
    }
}

PrototypeText.propTypes = {
    locale: PropTypes.object,
};

PrototypeText.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};

}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrototypeText);



/** WEBPACK FOOTER **
 ** ./src/components/objects/prototypeObjects/PrototypeText.js
 **/